import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getToken,
  GET_USER_ROLE_DETAILS,
  GET_HELLO_ADMIN_DETAILS,
  GET_TOTAL_COUNT,
  GET_USER_TYPE_DETAILS,
  GET_ALL_ROLES_DETAILS,
  getNetworkMenuId,
  GET_CHAIN_NAME,
  GET_PROVIDERS_BY_CHAIN_ID,
  GET_VIEW_HISTORY,
} from "../../Utils/types";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";

export const getUserRoleAction = (id) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetAllRolesList?userTypeId=${id}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.HELLO_ADMIN &&
        getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_USER_ROLE_DETAILS, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_USER_ROLE_DETAILS, null, dispatch);
    }
  });
};
export const getUserRoleFetchAction = (id) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetAllRolesList?userTypeId=${id}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.HELLO_ADMIN &&
        getNetworkMenuId()?.menuId,
    }
  );
};
export const getUserDetailByIdAction = (id) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetUser?uId=${id}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.HELLO_ADMIN &&
        getNetworkMenuId()?.menuId,
    }
  );
};

export const getUserTypeAction = () => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetAllUserTypesList`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.HELLO_ADMIN &&
        getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_USER_TYPE_DETAILS, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_USER_TYPE_DETAILS, null, dispatch);
    }
  });
};

export const getHelloAdminAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetAllUserDetailsList`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.HELLO_ADMIN &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getDispatch(
        GET_HELLO_ADMIN_DETAILS,
        res?.data?.results?.getAllUserDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRecords, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getDispatch(GET_HELLO_ADMIN_DETAILS, res?.data?.results, dispatch);
    }
  });
};

export const addUserDetailsAction = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/AddUpdateUser`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.HELLO_ADMIN &&
      getNetworkMenuId()?.menuId,
  });
};
export const activeInactiveUserDetailsAction =
  (id, booleanValue) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/ChangeUserActiveStatus?uId=${id}&IsActive=${booleanValue}`;
    return HttpUtil.makePOST(
      url,
      {},
      {
        Authorization: getToken(),
        ApiKey: API_KEY,
        MenuId:
          getNetworkMenuId()?.url === ROUTES?.HELLO_ADMIN &&
          getNetworkMenuId()?.menuId,
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      } else {
        getSnackbarSuccess("error", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      }
    });
  };

//roles

export const getRolesAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetAllManageRoles`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getDispatch(
        GET_ALL_ROLES_DETAILS,
        res?.data?.results?.getAllRoles,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRecords, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getDispatch(GET_ALL_ROLES_DETAILS, res?.data?.results, dispatch);
    }
  });
};

export const getRoleDetailByIdAction = (id) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetRole?roleId=${id}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  );
};

export const addRoleDetailsAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/AddUpdateRole`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getChainNameAction = () => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetChainProviders`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_CHAIN_NAME, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_CHAIN_NAME, null, dispatch);
    }
  });
};
export const getProviderByChainIdAction = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetProvidersByChainId`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PROVIDERS_BY_CHAIN_ID, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_PROVIDERS_BY_CHAIN_ID, null, dispatch);
    }
  });
};

export const getViewAdminHistoryAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkAdmin/GetChainProviderLogHistory`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_VIEW_HISTORY,
        res?.data?.results?.listChainHistory,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_VIEW_HISTORY, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
